import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Для чего разрабатывается дизайн-проект", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Проект информационных конструкций «РОСБАНК»", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите адрес размещения вывески", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Пример: г. Сургут, пр-кт Ленина, д 51/1", -1)
const _hoisted_7 = { class: "right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Проектировщик дизайн-проекта", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Пример: ООО \"Консалтинговая группа \"СЕВЕР\"\", другое", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Юридический адрес проектировщика", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Пример: г. Санкт-Петербург, наб.р. Фонтанки, д. 59, оф. 302", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите текст в родительном падеже",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.purpose_design) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.purpose_design]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите адрес",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.address) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.address]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _hoisted_8,
        _hoisted_9,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.designer_name_title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.designer_name_title) = $event)),
          editable: "",
          options: _ctx.designer_name_options,
          optionLabel: "name",
          placeholder: _ctx.designer_name_default.name,
          style: {"width":"480px"},
          onChange: _ctx.designer_name_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
        (_ctx.document.designer_name != _ctx.designer_name_default.name)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "input",
              type: "text",
              placeholder: "Введите название проектировщика",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.designer_name) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.document.designer_name]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите адрес",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.address_law) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.address_law]
        ])
      ])
    ])
  ]))
}